<template>
  <div class="topic-links" aria-label="关联题材表格">
    <div v-if="visibleLinks.length" class="linked-tables">
      <span>关联题材表格：</span>
      <router-link v-for="item in visibleLinks" :key="item.table_id" :to="`/wonder/topic/detail/${item.unique_key}`" class="topic-link" :title="item.evidence.map(topicDisplayName).join('；')">
        {{ topicDisplayName(item.name) }} <small>{{ item.status === 'automatic' ? '自动关联' : '人工选择' }}</small> →
      </router-link>
    </div>
    <details v-if="canManage" class="link-review" @toggle="onToggle">
      <summary>管理题材关联 <small>{{ candidates.length }} 个候选</small></summary>
      <p class="hint">系统默认选择最多6个高质量关联。可勾选其他候选或取消默认项，人工管理不限6个，取消后不自动补满。股票重合按当前表格成员计算。</p>
      <div v-for="item in candidates" :key="item.table_id" class="candidate">
        <div><label><input type="checkbox" :checked="isSelected(item)" :disabled="busy" :aria-label="`关联${topicDisplayName(item.name)}`" @change="toggle(item, $event)"> {{ statusLabel(item.status) }}</label> <router-link :to="`/wonder/topic/detail/${item.unique_key}`">{{ topicDisplayName(item.name) }}</router-link></div>
        <small>{{ item.evidence.map(topicDisplayName).join('；') }}<span v-if="item.common_stocks.length">（{{ item.common_stocks.join('、') }}）</span></small>
      </div>
      <label class="remember"><input v-model="remember" type="checkbox"> 将本次确认或排除用于今后相同标题的推荐</label>
      <form class="search" @submit.prevent="search">
        <input v-model.trim="query" aria-label="搜索题材表格" placeholder="输入题材表格名称" maxlength="100">
        <button type="submit" :disabled="searching || !query">{{ searching ? '搜索中…' : '搜索表格' }}</button>
      </form>
      <div v-for="item in searchResults" :key="`search-${item.id}`" class="search-result">
        <span>{{ topicDisplayName(item.name) }}</span><button type="button" :disabled="busy" @click="save({ table_id: item.id }, 'confirmed')">关联此表格</button>
      </div>
      <small v-if="searched && !searchResults.length">没有找到对应表格，保留未关联状态。</small>
      <p v-if="error" role="alert" class="error">{{ error }}</p>
    </details>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
import { topicDisplayName } from '@/utils/topicDisplayName'

export default {
  name: 'ReportTopicLinks',
  props: {
    reportId: { type: [String, Number], required: true },
    sectionIndex: { type: Number, required: true },
    contentHash: { type: String, default: '' },
    candidates: { type: Array, default: () => [] },
    canManage: { type: Boolean, default: false }
  },
  data: () => ({ query: '', searchResults: [], searched: false, searching: false, busy: false, remember: false, error: '' }),
  computed: {
    visibleLinks() { return this.candidates.filter(c => ['confirmed', 'automatic'].includes(c.status)) }
  },
  methods: {
    topicDisplayName,
    onToggle(event) { if (!event.target.open) this.error = '' },
    isSelected(item) { return ['confirmed', 'automatic'].includes(item.status) },
    toggle(item, event) {
      const selected = event.target.checked
      event.target.checked = this.isSelected(item)
      this.save(item, selected ? 'confirmed' : 'rejected')
    },
    statusLabel(status) { return ({ confirmed: '人工选择', automatic: '自动关联', rejected: '已排除', candidate: '未选中' })[status] || status },
    async search() {
      this.searching = true
      this.error = ''
      try {
        const res = await request_zzquant({ url: '/v3/topic-knowledge/catalogue', params: { q: this.query }, noRedirect: true })
        if (res.data.code !== 20000) throw new Error(res.data.message)
        this.searchResults = res.data.data.tables
        this.searched = true
      } catch (e) { this.error = e.response?.data?.detail || e.message || '搜索失败' }
      finally { this.searching = false }
    },
    async save(item, status) {
      this.busy = true
      this.error = ''
      try {
        const res = await request_zzquant({ url: `/v3/ai-report/detail/${this.reportId}/topic-links`, method: 'POST', noRedirect: true,
          data: { content_hash: this.contentHash, section_index: this.sectionIndex, table_id: item.table_id, status, remember: this.remember } })
        if (res.data.code !== 20000) throw new Error(res.data.message)
        this.$emit('saved')
      } catch (e) { this.error = e.response?.data?.detail || e.message || '保存失败' }
      finally { this.busy = false }
    }
  }
}
</script>

<style scoped>
.topic-links { color: var(--text-main); margin: 8px 0; font-size: 0.85rem; }
.linked-tables, .actions, .search, .search-result { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.topic-link { padding: 4px 8px; border: 1px solid var(--border-color); border-radius: 5px; }
.topic-link small, .hint, .candidate > small { color: var(--text-muted); }
.link-review { margin-top: 8px; padding: 8px; border: 1px solid var(--border-color); border-radius: 5px; background: var(--bg-card); }
summary { cursor: pointer; }
.candidate { padding: 8px 0; border-bottom: 1px solid var(--border-color); overflow-wrap: anywhere; }
button, input { background: var(--bg-card); color: var(--text-main); border: 1px solid var(--border-color); border-radius: 4px; padding: 4px 8px; }
button { cursor: pointer; } button:disabled { opacity: 0.5; }
.actions, .search, .remember { margin-top: 8px; }
.search input { flex: 1; min-width: 120px; }
.search-result { justify-content: space-between; padding: 5px 0; }
.error { color: var(--text-danger, var(--text-main)); }
</style>
